export { LeadCard } from './LeadCard';
export type { LeadCardProps } from './LeadCard.types';
